import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Assurez-vous que la langue par défaut est "FRA"
    const getDefaultLanguage = () => {
        const savedLanguage = localStorage.getItem('language');
        return savedLanguage ? savedLanguage : 'FRA'; // Définit "FRA" par défaut si aucune langue n'est sauvegardée
    };

    const [language, setLanguage] = useState(getDefaultLanguage());

    // Synchronise toujours la langue par défaut dans localStorage
    useEffect(() => {
        if (!localStorage.getItem('language')) {
            localStorage.setItem('language', 'FRA');
        }
    }, []);

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('language', lang); // Sauvegarde dans le localStorage
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
